export const ResidenceTypes = Object.freeze({
    resident: 'RESIDENT',
    citizen: 'CITIZEN',
})
